"use strict";

var vm = new Vue({
  el: "#app",
  delimiters: ["%%", "%%"],
  data: function data() {
    return {
      displayImage: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/bfcm1cat_grey.jpg",
      cats: 1,
      country: "",
      ingredients: false,
      pricePopup: false,
      promotion: "",
      step: 1,
      toyUpsell: true,
      upsell: true,
      upsell_taken: false,
      view: "original",
      weeks: 4,
      testVar: "",
      testProp: "",
      debug: false,
      toys: [{
        desc: "Enrich your cat’s environment with aerobic exercise.",
        img: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/ball_with_feather@2x.jpg",
        title: "Plush Fitness Ball",
        price: 3,
        quantity: 0,
        vid: 13964570624061
      }, {
        desc: "Make leaps and bounds in bonding with your cat.",
        img: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/wand_with_feather@2x.jpg",
        title: "Fitness Wand",
        price: 7,
        quantity: 0,
        vid: 13964570689597
      }, {
        desc: "Tickle your cat’s senses and get them playing.",
        img: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/cat_pillow@2x.jpg",
        title: "Catnip Toy Pillow",
        price: 5,
        quantity: 0,
        vid: 13964570656829
      }]
    };
  },
  beforeMount: function beforeMount() {
    var self = this;
    function getParameterByName(name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    var step = getParameterByName("step");
    if (step !== null && step !== undefined) {
      self.step = step;
    }
    //debug
    var debug = getParameterByName("debug");
    if (debug !== null && debug !== undefined) {
      self.debug = true;
    }

    function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    }
    var clumpingCookie = getCookie("_clumping_sa");
    if (clumpingCookie !== undefined && clumpingCookie !== null) {
      if (self.view !== undefined) {
        // self.view = "clumping";
      }
    }
  },
  mounted: function mounted() {
    console.log("Vue.js mounted");
    var self = this;
    function getParameterByName(name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    //check for # of cats in URL
    var cats = getParameterByName("cats");
    if (cats !== null && cats !== undefined) {
      console.log("Found " + cats + " cats in URL!");
      var cat_number = Number(cats);
      if (cat_number == 1) {
        this.cats = 1;
      }
      if (cat_number == 2) {
        this.cats = 2;
      }
      if (cat_number == 3 || cats_number == 4) {
        this.cats = 4;
      }
    }
    //check for possible promotion in URL
    var promotion = getParameterByName("utm_campaign");
    if (promotion !== undefined && promotion !== null) {
      if (promotion.toLowerCase() == "laborday") {
        this.promotion = "laborday";
      }
    }
    //check for forceView in URL
    var forceView = getParameterByName("forceView");
    if (forceView !== null && forceView !== undefined) {
      this.view = forceView;
    }
    //geotracking stuff
    var getCookie = function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    };
    var country = getCookie("_plgeo");
    if (country !== undefined && country !== null) {
      console.log("SETTING COUNTRY!", country);
      this.country = country;
    } else {
      setTimeout(function () {
        console.log("TIMEOUT GET COOKIE");
        country = getCookie("_plgeo");
        if (country !== undefined && country !== null) {
          console.log("TIMEOUT RESULT: ", country);
          self.country = country;
        }
      }, 4500);
    }
  },

  computed: {
    cart: function cart() {
      var self = this;
      var cart = {};
      cart.quantity = 1;
      cart.id = getVid();
      cart.properties = {
        shipping_interval_frequency: 4,
        shipping_interval_unit_type: "Weeks",
        subscription_id: 225784,
        test: "C"
      };
      function getVid() {
        if (self.cats == 1) {
          return 29531333525565;
        }
        if (self.cats == 2) {
          return 29531342405693;
        }
      }
      return cart;
    },
    discount: function discount() {
      if (this.cats == 1) {
        return "BF191M3";
      }
      if (this.cats == 2) {
        return "BF192M3";
      }
      if (this.cats == 3) {
        return "BF193M3";
      }
    },
    toyAddons: function toyAddons() {
      var toys = this.toys;
      var arr = [];
      toys.forEach(function (toy) {
        if (toy.quantity > 0) {
          arr.push({ id: toy.vid, quantity: toy.quantity });
        }
      });
      if (arr.length > 0) {
        return arr;
      } else {
        return false;
      }
    },
    image: function image() {
      if (this.cats == 1) {
        return "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/1cat_nowt.jpg";
      }
      if (this.cats == 2) {
        return "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/2cat_nowt.jpg";
      }
      if (this.cats == 3) {
        return "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/3cat_nowt.jpg";
      }
    },
    images: function images() {
      var imageArray = [];
      imageArray.push(this.image);
      imageArray.push("https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/bfcm_back.jpg");
      imageArray.push("https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/bfcm_box.jpg");
      imageArray.push("https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/bfcm_icons.jpg");
      return imageArray;
    },
    price: function price() {
      if (this.cats == 1) {
        return "$29.00";
      }
      if (this.cats == 2) {
        return "$54.00";
      }
    }
  },
  methods: {
    addItemsToCart: function addItemsToCart() {
      var self = this;
      console.log("Adding items to cart.");
      if (self.toyAddons !== false) {
        addToys();
      } else {
        if (self.upsell_taken) {
          addFood();
        } else {
          addCart();
        }
      }
      function addFreeToy() {
        if (self.country == "US") {
          var catToy = {
            id: 29523702513725,
            quantity: 1
          };
          axios.post("/cart/add.js", catToy).then(function (response) {
            console.log("Toy added to cart.");
            if (self.upsell_taken) {
              addFood();
            } else {
              addCart();
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          if (self.upsell_taken) addCart();
        }
      }
      function addToys() {
        if (self.country == "US") {
          var _addToyToCart = function _addToyToCart(counter, length) {
            var toy = self.toyAddons[counter];
            axios.post("/cart/add.js", toy).then(function (response) {
              console.log("Toy added to cart.");
              counter++;
              if (counter == length) {
                if (self.upsell_taken) {
                  addFood();
                } else {
                  addCart();
                }
              } else {
                _addToyToCart(counter, length);
              }
            });
          };

          _addToyToCart(0, self.toyAddons.length);
        } else {
          if (self.upsell_taken) addCart();
        }
      }
      function addFood() {
        var food = {
          id: 14177898758205,
          quantity: 1,
          properties: {
            shipping_interval_frequency: 4,
            shipping_interval_unit_type: "Weeks",
            subscription_id: 171263,
            recurring_price: 25.0,
            bundle: "true"
          }
        };
        axios.post("/cart/add.js", food).then(function (response) {
          console.log("Food added to cart..");
          addCart();
        }).catch(function (error) {
          console.log(error);
        });
      }
      function addCart() {
        axios.post("/cart/add.js", self.cart).then(function (response) {
          console.log("Litter added to cart.");
          self.postEvents();
          self.goToCheckout();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    clearCart: function clearCart() {
      var self = this;
      axios.post("/cart/clear.js").then(function (response) {
        console.log("Cart cleared.");
        self.addItemsToCart();
      }).catch(function (error) {
        console.log(error);
      });
    },
    clearCookies: function clearCookies() {
      document.cookie = "_clumping_sa=false;domain=prettylitter.com;path=/;expires=Tue Dec 01 2020 00:00:00 GMT-0800";
      window.location.href = "/pages/get-started";
    },
    goToCheckout: function goToCheckout() {
      var self = this;
      var token = undefined;
      function get_cookie(name) {
        return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
      }
      do {
        token = get_cookie("cart");
      } while (token == undefined);

      var myshopify_domain = "pretty-litter.myshopify.com";
      var ga_linker = "";
      try {
        ga_linker = ga.getAll()[0].get("linkerParam");
      } catch (err) {
        ga_linker = "";
      }
      var customer_param = "";
      var checkout_url = "https://checkout.prettylitter.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + "&discount=" + self.discount + "&" + customer_param;
      console.log(checkout_url);
      if (this.promotion == "laborday" && this.country == "US") {
        var discount = this.cats == 1 ? "LABOR5" : this.cats == 2 ? "LABOR10" : "LABOR15";
        checkout_url += "&discount=" + discount;
      }
      window.location.href = checkout_url;
    },
    initializeSwiper: function initializeSwiper() {
      console.log("initializeSwiper");
      setTimeout(function () {
        var mySwiper = new Swiper(".swiper-container", {
          direction: "horizontal",
          loop: false,
          slidesPerView: 3,
          autoHeight: true,
          noSwiping: true,
          noSwipingClass: "swiper-slide",
          spaceBetween: 20,
          breakpoints: {
            // when window width is <= 767px
            767: {
              noSwiping: false,
              slidesPerView: 1.25,
              spaceBetween: 10
            }
          },
          centeredSlides: true,
          initialSlide: 1
        });
      }, 650);
    },
    postEvents: function postEvents() {
      //add item to our AWS DB
      var getCookie = function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
      };
      var uuid = getCookie("_pltrkg");
      //pinterest
      if (typeof pintrk !== "undefined") {
        console.log("pintrk defined");
        pintrk("track", "addtocart", {
          value: 100,
          order_quantity: 1,
          currency: "USD"
        });
      }
    },
    scrollTop: function scrollTop() {
      $("html, body").animate({
        scrollTop: $("#product-options").offset().top
      }, 500);
    },
    seeToys: function seeToys(obj) {
      console.log("seeToys");
      var self = this;
      console.log("BUTTON ID:");
      console.log(obj.target.id);
      if (obj.target.id == "checkoutStep2") {
        document.getElementById(obj.target.id).innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
        if (this.toyUpsell == true) {
          setTimeout(function () {
            if (self.toyUpsell == true && self.country == "US") {
              self.step = 3;
              window.scrollTo({ top: 0, behavior: "smooth" });
              self.initializeSwiper();
            } else {
              self.startCheckout();
            }
          }, 1500);
        } else {
          self.startCheckout();
        }
      } else {
        console.log("else...");
        if (self.toyUpsell == true && self.country == "US") {
          self.step = 3;
          self.scrollTop();
          self.initializeSwiper();
        } else {
          obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
          self.startCheckout();
        }
      }
    },
    startCheckout: function startCheckout(obj) {
      console.log("startCheckout");
      if (!this.processing) {
        this.processing = true;
        this.clearCart();
        if (this.step == 3) {
          if (this.toyAddons !== false) {
            obj.target.innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
          } else {
            obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
          }
        } else {
          if (this.upsell_taken == true || this.step == 1) {
            obj.target.innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
          }
          if (this.upsell_taken == false || this.step == 2) {
            obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
          }
        }
      }
    },
    stepTwo: function stepTwo(obj) {
      var self = this;
      if (obj.target.id == "checkoutStep1") {
        document.getElementById(obj.target.id).innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
      }
      setTimeout(function () {
        if (self.toyUpsell == true && self.country == "US") {
          self.step = 2;
          window.scrollTo({ top: 0, behavior: "smooth" });
          self.initializeSwiper();
        } else {
          self.startCheckout;
        }
      }, 1500);
    },
    togglePopup: function togglePopup() {
      this.pricePopup = !this.pricePopup;
    }
  }
});

//nonvue items
function HashHandler() {
  console.log("The Hash has changed!");
  if (window.location.hash == "#step2") {
    window.scrollTo(0, 0);
    vm.step = 2;
  } else if (window.location.hash == "#step3") {
    window.scrollTo(0, 0);
    vm.step = 3;
  } else {
    window.scrollTo(0, 0);
    vm.step = 1;
  }
}

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}
function setCookie(name, value, expiration) {
  document.cookie = name + "=" + value + "; domain=prettylitter.com; path=/; expires=" + expiration + ";";
}
var clumping_cookie = getCookie("_clumping");
if (clumping_cookie == undefined) {
  setCookie("_clumping_sa", "true", "Tue Dec 01 2020 00:00:00 GMT-0800");
}

window.addEventListener("hashchange", HashHandler, false);